import { createContext } from "react";

import { AvailableFederation } from "@/types";
import { noop } from "@/utils/function.utils";

export type SwitchOrganizationGuard = (proceed: () => void) => boolean;

export type CurrentOrganizationContextType = {
  organization: AvailableFederation | null;
  /** True when the org is intentionally absent (platform-only mode), not merely unresolved. */
  isPlatformOnly: boolean;
  accessibleFederationsCount: number;
  availableFederationsCount: number;
  loading: boolean;
  /** Pass `null` to enter platform-only mode (only honored when the user can manage the platform). */
  switchOrganization: (organizationId: string | null) => void;
  setSwitchOrganizationGuard: (guard: SwitchOrganizationGuard | null) => void;
  isError: boolean;
};

export const CurrentOrganizationContext = createContext<CurrentOrganizationContextType>({
  organization: null,
  isPlatformOnly: false,
  accessibleFederationsCount: 0,
  availableFederationsCount: 0,
  loading: false,
  switchOrganization: noop,
  setSwitchOrganizationGuard: noop,
  isError: false,
});
